var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3,
    cy: 19.3,
    r: 14.6212,
    fill: "#B8B990"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21667 19.3C3.21667 10.422 10.422 3.21667 19.3 3.21667C28.178 3.21667 35.3833 10.422 35.3833 19.3C35.3833 28.178 28.178 35.3833 19.3 35.3833C10.422 35.3833 3.21667 28.178 3.21667 19.3ZM6.43321 19.3C6.43321 26.3927 12.2071 32.1667 19.2999 32.1667C26.3926 32.1667 32.1665 26.3927 32.1665 19.3C32.1665 12.2073 26.3926 6.43333 19.2999 6.43333C12.2071 6.43333 6.43321 12.2073 6.43321 19.3Z",
    fill: "#8F920B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6823 12.1912L16.0834 22.7901L11.9178 18.6406L9.65002 20.9083L16.0834 27.3417L28.95 14.475L26.6823 12.1912Z",
    fill: "#8F920B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle24Px);
export default __webpack_public_path__ + "static/media/check_circle_24px.ba3f0a88f1b615af775f26f0716e089e.svg";
export { ForwardRef as ReactComponent };